<script setup>
import { useDetectDevice } from '@/composables/device'

import NotificationsView from '@/components/NotificationsView.vue'
import NotificationsGrid from '@/components/NotificationsGrid.vue'

const { isMobile } = useDetectDevice()

</script>
<template>
  <notifications-view v-if="isMobile" />
  <notifications-grid v-else />
</template>
